import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import globalTranslations from '../../../i18n/globalTranslations';
import { modelOf } from '../../../prop-types';
import RouteService from '../../../services/RouteService';
import AccountStore from "../../../store/AccountStore";
import ConfigStore from '../../../store/ConfigStore';
import TranslationStore from "../../../store/TranslationStore";
import Paths from '../../../types/Paths';
import AlternateLink from '../AlternateLink';
import CanonicalLink from '../CanonicalLink';
import SEODescription from '../SEODescription';
import SEOTitle from '../SEOTitle';
import SEOOrganizationSchema from "../../schema/common/SEOOrganizationSchema";
import useNavigationLogo from "../../header/NavigationLogo/hook";

const SEOHomePage = ({ accountStore, configStore, translationStore, routeService }) => {
  const title = configStore.configurationTexts.CONF_SEO_TITLE ||
    globalTranslations.homeTitle;
  const name = `${configStore.store.name} ${configStore.languageTexts.TEXT_SEO_STORE_NAME_ADD}`;
  const description = configStore.configurationTexts.CONF_SEO_DESCRIPTION;
  const searchPath = window.location.origin + routeService.getPath(Paths.AdvancedSearch);

  const [getTranslatedLogo] = useNavigationLogo({
    accountStore,
    translationStore,
    useScrollingHeader: false,
  });

  const logo = getTranslatedLogo();


  return (
    <>
      <SEOTitle
        title={title}
        noSuffix={configStore.configurationTexts.CONF_SEO_TITLE !== ''}
      />
      {description && (
        <SEODescription
          content={description}
        />
      )}
      <SEOOrganizationSchema data={{
        title,
        name,
        description,
        logo,
        searchPath,
      }} />
      <CanonicalLink path={routeService.getPath(Paths.FrontPage)} />
      <AlternateLink path={Paths.FrontPage} />
    </>
  );
};

SEOHomePage.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  translationStore: modelOf(TranslationStore).isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
};

export default inject(
  'accountStore',
  'configStore',
  'translationStore',
  'routeService'
)(observer(SEOHomePage));
